import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ApprovedFundingRequestDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { resetRetrieveApprovedFundingRequest, retrieveApprovedFundingRequest } from "./retrieve-approved-funding-request";

const initialState: RetrievalState<ApprovedFundingRequestDetailVM | null> = {
  fetching: "idle",
  data: null,
};

export const retrieveApprovedFundingRequestReducer = createReducer<RetrievalState<ApprovedFundingRequestDetailVM | null>>(
  initialState,
  builder => {
    builder.addCase(retrieveApprovedFundingRequest.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(retrieveApprovedFundingRequest.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(retrieveApprovedFundingRequest.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetRetrieveApprovedFundingRequest, () => {
      return initialState;
    });
  },
);
